import { Component } from '@angular/core';

@Component({
  selector: 'app-ac-icon-arrow-down',
  templateUrl: './ac-icon-arrow-down.component.html',
  styleUrls: ['./ac-icon-arrow-down.component.scss']
})
export class AcIconArrowDownComponent {

}
